import React from 'react'
import * as C from "../componentsM/index";

const AfricaEuropeAsia = () => {
    return (
        <>

            <C.Hero title={"AFRICA, EUROPE & ASIA"} image={"/hero/22.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>


                    <p>The student community of the school is evenly divided into three sub-groups titled Africa (Yellow), Europe (Blue) and Asia (Green). Besides creating awareness of other continents and cultures, this diversity in unity creates a healthy, fun and competitive environment. It is heartening to see the blues, yellows and greens shout, scream and cheer their peers in the Annual Swimming Gala, TIS Olympics and inter-school tournaments.</p>



                </div>


            </section>

        </>
    )
}

export default AfricaEuropeAsia